export default __webpack_public_path__ + "static/media/64.6fcd0f1d.svg";